import React from 'react';
import '../App.css';

function LandingIssaaf() {
  return (
    <div className="issaaf-landing">
      <header className="issaaf-header">
        <h1 className="issaaf-title">The SUSE Test Catalog</h1>
        <p className="issaaf-tagline">Test Library. Test Plans</p>
        <a href="/testcatalog" className="issaaf-button">
          Explore Catalog
        </a>
      </header>
      <footer className="issaaf-footer-links">
        <a href="https://openqa.suse.de" target="_blank" rel="noreferrer">
          openQA
        </a>
        <a
          href="http://dashboard.qam.suse.de/"
          target="_blank"
          rel="noreferrer"
        >
          QAM Dashboard
        </a>
        <a href="https://monitor.qa.suse.de/" target="_blank" rel="noreferrer">
          QA Monitoring
        </a>
        <a
          href="https://linux-test-project.readthedocs.io/en/latest/index.html"
          target="_blank"
          rel="noreferrer"
        >
          LTP documentation
        </a>
        <a href="http://open.qa/api/testapi/" target="_blank" rel="noreferrer">
          openQA test API
        </a>
      </footer>
    </div>
  );
}

export default LandingIssaaf;
